import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { environment } from '../../../environments/environment';

@Injectable()
export class FirmantesService
{
    constructor(public http: HttpClient, ) { }

    traeFirmantes(agpId: any)
    {
        return this.http.get(`${environment.urlApipagos}/firmantes/agpId/${agpId}`,
               { headers: this.armaCabecera() }).toPromise();
    }
   
    armaCabecera()
    {
        return new HttpHeaders({
            'Content-Type':'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE',
            'Access-Control-Allow-Origin': '*',
        });
    }
}
